<template>
  <div class="recommend">
    <h3>配套题库</h3>
    <div class="more">
      <RouterLink target="_blank" to="/tests">
        <span>更多</span>
        <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
  </div>
  <Transition name="fade">
    <div v-if="testList.length" class="recommend-cate">
      <div class="cate-left" v-for="item in testList" :key="item.index">
        <RouterLink
          target="_blank"
          :to="`/tests/testsdetail?clID=${item.clID}&id=${item.id}`"
        >
          <i>试题</i>
          <img v-lazy="item.testsCoverImg" alt="" />
          <el-text line-clamp="2">
            {{ item.testsName }}
          </el-text>
        </RouterLink>
        <div class="cate-desc">
          <h3>&yen;{{ item.grade.grPrice }}</h3>
          <RouterLink
            target="_blank"
            :to="`/tests/testsdetail?clID=${item.clID}&id=${item.id}`"
          >
            <el-button size="small">查看详情</el-button>
          </RouterLink>
        </div>
      </div>
    </div>
    <NewsSkeleton v-else />
  </Transition>
</template>
<script>
import NewsSkeleton from "../common/news-skeleton.vue";
export default {
  components: {
    NewsSkeleton,
  },
  props: {
    testList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.recommend {
  display: flex;
  height: 50px;
  width: 400px;
  align-items: center;
  justify-content: space-between;
  background: rgb(244, 244, 244);
  h3 {
    margin-left: 10px;
  }
  .more {
    a {
      display: flex;
      align-items: center;
      margin-right: 10px;
      color: #999;
      &:hover {
        color: @shColor;
      }
    }
  }
}
.recommend-cate {
  display: flex;
  justify-content: space-between;
  width: 400px;
  height: 210px;
  .cate-left {
    width: 195px;
    height: 210px;
    position: relative;
    border: 1px solid rgb(244, 244, 244);
    a {
      position: relative;
      width: 195px;
      margin-right: 5px;

      img {
        width: 195px;
        height: 120px;
      }
      /* .grade {
        position: absolute;
        font-weight: bold;
        top: 32%;
        left: 36.5%;
      }
      .grade1 {
        position: absolute;
        font-weight: bold;
        top: 32%;
        left: 31.5%;
      } */
      i {
        display: inline-block;
        position: absolute;
        top: -49px;
        right: 0;
        width: 30px;
        height: 15px;
        text-align: center;
        line-height: 15px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 2px;
      }
      span {
        margin: 5px 5px 5px 5px;
        &:hover {
          color: @shColor;
        }
      }
    }
    .cate-desc {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      h3 {
        width: 80px;
        margin-left: 10px;
        color: #fd7502;
      }
      a {
        display: inline-block;
        height: 22px;
        margin-bottom: 5px;
        width: 80px;
      }
    }
  }
}
/* .notice {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background: rgb(244, 244, 244);

  div {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 3px;
      height: 20px;
      background: @shColor;
    }
    h3 {
      margin-left: 10px;
    }
  }
  a {
    display: flex;
    align-items: center;
    color: #999;
    &:hover {
      color: @shColor;
    }
  }
}
.data-recomend {
  display: flex;
  justify-content: space-between;
  width: 400px;
  height: 210px;
  .cate-left {
    width: 195px;
    height: 210px;
    position: relative;
    border: 1px solid rgb(244, 244, 244);
    a {
      width: 195px;
      margin-right: 5px;

      img {
        width: 195px;
        height: 120px;
      }
      i {
        display: inline-block;
        position: absolute;
        top: 0px;
        right: 0;
        width: 30px;
        height: 15px;
        text-align: center;
        line-height: 15px;
        color: #fff;
        font-size: 12px;
        background: #0a7fec;
        border-radius: 2px;
      }
      span {
        margin: 5px 5px 5px 5px;
        &:hover {
          color: @shColor;
        }
      }
    }
    .cate-desc {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      h3 {
        width: 80px;
        margin-left: 10px;
        color: #fd7502;
      }
      a {
        display: inline-block;
        height: 22px;
        margin-bottom: 5px;
        width: 80px;
      }
    }
  }
  .cate-right {
    width: 195px;
    height: 210px;
    position: relative;
    border: 1px solid rgb(244, 244, 244);
    a {
      width: 195px;
      margin-right: 5px;

      img {
        width: 195px;
        height: 120px;
      }
      i {
        display: inline-block;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 38px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
      }
      span {
        margin: 5px 5px 5px 5px;
        &:hover {
          color: @shColor;
        }
      }
    }
    .cate-desc {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      h3 {
        width: 80px;
        margin-left: 10px;
        color: #fd7502;
      }
      a {
        display: inline-block;
        width: 80px;
      }
    }
  }
} */
</style>
